import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "title",
    "subtitle",
    "titleSource",
    "subTitleSource",
    "content",
    "footer",
    "footerSource",
    "footerItem",
  ]

  open(e) {
    e.preventDefault()
    const link = e.currentTarget
    this.dialogTarget.showModal()
    this.loadingIndicator = this.contentTarget.innerHTML
    this.contentTarget.src = link.getAttribute("href")
  }

  safeClose(e) {
    if (this.contentTarget.contains(e.target)) return
    this.close()
  }

  close() {
    this.dialogTarget.close()
    this.resetContent()
  }

  titleSourceTargetConnected(e) {
    const title = e.getAttribute("title")
    this.setTitle(title)
  }

  subTitleSourceTargetConnected(e) {
    const subtitle = e.innerHTML
    this.setSubtitle(subtitle)
  }

  footerSourceTargetConnected() {
    this.footerTarget.innerHTML = ""
    this.footerItemTargets.forEach((item) => {
      this.footerTarget.appendChild(item)
    })
  }

  resetContent() {
    this.contentTarget.innerHTML = this.loadingIndicator
    this.setTitle("")
    this.setSubtitle("")
  }

  setTitle(value) {
    this.titleTarget.textContent = value
  }

  setSubtitle(value) {
    this.subtitleTarget.innerHTML = value
  }
}
